import React, { useState, useEffect, useRef } from 'react'
import { Link, NavLink, BrowserRouter, useHistory } from 'react-router-dom';
//import { browserHistory } from 'react-router'
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";

import { useDispatch } from 'react-redux';
import * as axios from "axios";
import Swal from 'sweetalert2';
import CONFIG from "../../config";
import { getAuthHeader } from "../../utils";
import { WindowSharp } from '@mui/icons-material';

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};


const GeneratePassword = () => {


  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showpass, setShowpass] = useState(false);
  const [showpassconfirm, setShowpassconfirm] = useState(false);

    // get url param
  const search = window.location.search;
  const params = new URLSearchParams(search);
  //const url = new URL(window.location.href);
  if (!params.get('token')) {
    window.location.href= "/login" 
  }
  const acctoken = params.get('token')
  
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShownConfirm, setPasswordShownConfirm] = useState(false);
  
  const [givepassword, setGivePassword]=useState("");
  const [givepasswordconfirm, setGivePasswordConfirm]=useState("");

  
const savepwd = (e) => {
    e.preventDefault();
    if(givepassword.length > 5){
        if(givepassword == givepasswordconfirm){
            var jsonToPost = {
                "token":acctoken,
                "password":givepassword,
            }
            Updatepwd(jsonToPost).then((res) => {
                if(res.status){
                    let result = Swal.fire({
                        icon: "success",
                        title: 'Done',
                        text: 'Congratulations!',
                        footer: 'Your Password Has Been Changed Successfully.'
                    }).then(function (result) {
                        window.location.href= "/login" 
                    })              
                 }
                else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong!',
                        footer: res.message
                    })
                }
            })
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Password does not match.',
            })
        }
    }else{
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Password should be alteast 6 characters.',
        })
    }

}


const Updatepwd = (model) => {
    const url = `${CONFIG.BASE_URL}/user/updatepwd`;
    return axios.post(url, model, getAuthHeader()).then((response) => {
      return response.data;
    });
};



const togglePassword = () => {
    setPasswordShown(!passwordShown);
    if(showpass == true){
        setShowpass(false);
    }else{
        setShowpass(true);
    }
};

const togglePasswordConfirm = () => {
    setPasswordShownConfirm(!passwordShownConfirm);
    if(showpassconfirm == true){
        setShowpassconfirm(false);
    }else{
        setShowpassconfirm(true);
    }
};

  
  return (
    <>
      <section className="loginbg">
        <div className="hero-section hero-section-login">
          <div className="container">
            <div className="hero-container">
            <div className="hero-left">
              <h1>Login to Get Your Dream Job</h1>

              <Form className="auth_form banner-form p-4 mt-5 shadow" onSubmit={savepwd}>
                <Link to="/" class="text-center font-weight-light my-4">
                  <img src="assets/img/logo.png" class="mb-4 logo img-fluid" />
                </Link>
                <div class="form-group">
                  <Input
                    type="hidden"
                    className="form-control py-4 rounded-pill"
                    placeholder="Enter Token Code"
                    name="code"
                    value={acctoken} 
                  />
                </div>
                <div class="form-group position-relative">
                  <Input
                    type={passwordShown ? "text" : "password"}
                    className="form-control py-4 rounded-pill"
                    placeholder="Enter New Password"
                    name="password"
                    value={givepassword} onChange={(e) => setGivePassword(e.target.value)} 
                    validations={[required]}
                  />
                  <buttton onClick={togglePassword} className="pwdeye">{showpass ? <i class="bi bi-eye"></i> : <i class="bi bi-eye-slash"></i>}</buttton>
                </div>
                <div class="form-group position-relative">
                  <Input
                    type={passwordShownConfirm ? "text" : "password"}
                    className="form-control py-4 rounded-pill"
                    placeholder="Enter Confirm Password"
                    name="password1"
                    value={givepasswordconfirm} onChange={(e) => setGivePasswordConfirm(e.target.value)} 
                    validations={[required]}
                  />
                  <buttton onClick={togglePasswordConfirm} className="pwdeye">{showpassconfirm ? <i class="bi bi-eye"></i> : <i class="bi bi-eye-slash"></i>}</buttton>
                </div>
                <div class="form-group d-flex align-items-center justify-content-center mt-4 mb-0">
                  <button className="btn btn-primary-custom mx-2 w-100">
                    SUBMIT
                  </button>
                  {loading && (
                    <span className="spinner-border spinner-border-sm"></span>
                  )}
                </div>
                {message && (
                  <div className="form-group">
                    <div className="alert alert-danger" role="alert">
                      {message}
                    </div>
                  </div>
                )}
              </Form>
            </div>
            <div className="hero-right d-none d-md-block mt-5">
              <img src="/assets/home/loginbanner.png" alt="Login Image" className="pt-5 mt-5" /> 
            </div>
            </div>

          </div>

        </div>
      </section>

    </>
  )

}


export default GeneratePassword